<div class="text-center" style="margin-top: 125px">
  <p class="text-white h1">{{text}} <strong class="secundary-color">{{subtext}}</strong></p>
  <div>
    <img src="./assets/svg/loading.svg" style="width: 125px; height: 125px" alt="">
  </div>
</div>
